import { ActivatedRoute, Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import * as Const from '../../shared/constants';

import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { IEntrada } from 'src/app/interfaces/entrada';
import { EntradasService } from 'src/app/services/datos/entradas.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ArticulosService } from 'src/app/services/datos/articulos.service';
import { IArticulo } from 'src/app/interfaces/articulo';

@Component({
  selector: 'app-entrada-add',
  templateUrl: './entrada-add.component.html',
  styleUrls: ['./entrada-add.component.scss']
})
export class EntradaAddComponent implements OnInit {


  // Usar constantes en el template
  Const = Const
  private id_entrada: number | null = null

  @ViewChild('txtEan') txtEan!: ElementRef;

  entrada: IEntrada = {}
  public articulo: IArticulo = {}
  public paleSelected: number | null = null;
  public paleLlenoFlag: boolean = false;
  public dataHistotico: any[] = [];

  public entradaForm: FormGroup = new FormGroup({});

  public enviado: { ean: boolean, cantidad: boolean } = { ean: false, cantidad: false };
  public loading: boolean = false;

  constructor(
    private entradaSrv: EntradasService,
    public notifciSrv: NotificacionesService,
    private articulosSrv: ArticulosService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {

    this.entradaForm = this.fb.group({
      ean: ['', Validators.required],
      cantidad: [1, [Validators.required, Validators.min(1), Validators.max(99999)]],
      pale: ['']
    });

    // Suscribirse a los parámetros de la url
    this.activatedRoute.params.subscribe(params => {
      this.id_entrada = +params['id_entrada']
      this.recargarDatos();
    })

    this.focoEan();

  }


  // Get entrada con detall
  getEntrada(): Observable<any> {
    const opcionesList = { id: this.id_entrada! }
    this.loading = true;

    return this.entradaSrv.getLista(opcionesList).pipe(
      tap(resp => {
        console.log('__getEntrada() resp', resp);

        this.loading = false;
        if (resp.error) {
          this.notifciSrv.aviso('error', resp.mensaje);
          this.router.navigate(['/pda']);
          return
        }
        if (resp.data.length == 0) {
          this.notifciSrv.aviso('error', 'No existe entrada con ese id');
          this.router.navigate(['/pda']);
          return
        }
        if (resp.data[0].swEditPda !== '1') {
          this.notifciSrv.aviso('error', 'No se puede editar esta entrada desde PDA');
          this.router.navigate(['/pda']);
          return
        }
        this.entrada = resp.data[0];
        console.log('__getEntrada() id_entrada:', this.id_entrada);
        console.log('__getEntrada():', this.entrada);

      })
    )
  }

  recargarDatos() {
    this.focoEan();
    this.getEntrada().subscribe();
  }

  // Valida si existe EAN para este Cliente
  validaEan() {
    this.paleSelected = null;
    this.articulo = {};
    this.enviado.ean = true;
    const ean = this.f['ean'].value;
    if (!ean) return;

    this.loading = true;
    this.articulosSrv.getByEan(this.entrada.id_cliente!, ean).subscribe((resp) => {
      this.loading = false;

      console.log(`__validaEan() resp`, resp);

      const control = this.f['ean'];
      if (resp.error) {
        if (control) control.setErrors({ apiError: resp.mensaje });
        this.limpiaDatos();
        return;
      }

      if (resp.data.swLote == '1') {
        // this.notifciSrv.aviso('info', 'El artículo gestiona lotes'); 
        if (control) control.setErrors({ apiError: 'El artículo gestiona lotes, debe ser entrado desde el Administrador' });
        return;
      }

      this.articulo = resp.data;
      this.f['ean'].setErrors(null);

      this.asignaPale()

    });
  }

  validaCantidad() {
    this.enviado.cantidad = true;
  }

  asignaPale() {
    if (!this.articulo.id) return;
    this.paleSelected = null;

    // Actualizar datos de la entrada
    this.getEntrada().subscribe(() => {
      const detall = this.entrada.detall || [];

      // Buscar el último palé donde existe este artículo
      const lastEntry = [...detall].reverse().find(d => d.id_articulo === this.articulo.id);

      if (lastEntry) {
        this.paleSelected = lastEntry.pale!;
      } else {
        // Si no existe, buscar el máximo palé actual o empezar en 1
        const maxPale = detall.reduce((max, item) => (item.pale! > max ? item.pale! : max), 0);
        this.paleSelected = maxPale + 1;
      }

      this.f['pale'].setValue(this.paleSelected);
    });
  }

  paleLleno() {
    if (!this.articulo.ean) return;
    this.paleSelected = null;

    // Actualizar datos de la entrada y continuar solo cuando finalice
    this.getEntrada().subscribe(() => {
      this.paleLlenoFlag = !this.paleLlenoFlag;

      if (this.paleLlenoFlag) {
        const detall = this.entrada.detall || [];
        const maxPale = detall.reduce((max, item) => (item.pale! > max ? item.pale! : max), 0);
        this.paleSelected = maxPale + 1;
        this.f['pale'].setValue(this.paleSelected);
      } else {
        this.asignaPale()
      }
    });
  }

  enviar() {
    // Enviar datos    
    this.focoEan();
    if (!this.articulo.ean) return;

    // Actualizar datos de la entrada y continuar solo cuando finalice
    this.getEntrada().subscribe(() => {
      const data = {
        id_entrada: this.id_entrada,
        cantidad: this.f['cantidad'].value,
        pale: this.f['pale'].value,
        articulo: this.articulo
      }

      this.loading = true;
      console.log('__addLinea data:', data);

      this.entradaSrv.addLinea(data).subscribe(resp => {
        console.log('__addLinea resp:', resp);
        this.loading = false;
        if (resp.error) {
          this.notifciSrv.aviso('error', resp.mensaje);
          this.recargarDatos();
          return;
        }

        this.recargarDatos();
        this.notifciSrv.aviso('success', resp.mensaje);
        this.dataHistotico.push(data);

      })

      this.enviado.ean = false;
      this.enviado.cantidad = false;

      this.resetForm();
      this.limpiaDatos();
    });

    return
  }






  ////// AUX ///// 

  get f() {
    return this.entradaForm.controls;
  }
  limpiaDatos() {
    this.articulo = {};
    this.paleSelected = null;
    this.paleLlenoFlag = false;
  }

  resetForm() {
    this.f['ean'].setValue('');
    this.f['cantidad'].setValue(1);
    this.f['pale'].setValue('');
  }

  toUpper(fieldName: string) {
    const formControl = this.f[fieldName];

    if (formControl && formControl.value) {
      formControl.setValue(formControl.value.toUpperCase());
    }
  }

  // Poner foco en el campo ean
  focoEan() {
    setTimeout(() => {
      this.txtEan.nativeElement.focus();
    }, 500);
  }

}
